import icons from './icons.json'
import { dialogLabelOption } from './miniComprehensive'

export const thirdparty_comprehensive: BenefitStoreContext[string] = {
	description: 'Get your vehicles on the road without worry for ₦15,000 only.',
	product_title: 'Protect your business vehicle against damages caused to others on the road',
	card_label: 'Liability coverage for injuries and property damage to others. From mcg_price per vehicle annually.',
	dialogLabels: dialogLabelOption,
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'NIID and Validity: Our auto insurance policies are licensed and genuine. Once purchase and inspection is completed, the policy is automatically registered on NIID Database.',
				'Insurance Certificate: Once activated, your insurance certificate is automatically generated and emailed to you. You can always present the certificate from your email to officials or print it in a hard copy format.'
			]
		},
		'How to get covered': {
			icon: icons.get_covered_icon,
			isOpen: false,
			value: [
				'Purchase a third-party plan.',
				'Submit all necessary information and documents.',
				'Activate your policy with your vehicle details to receive your insurance certificate.'
			]
		},
		'Your Business Will Enjoy': {
			isOpen: false,
			icon: icons.business,
			value: [
				'Protection for third-party property damage up to ₦3,000,000.',
				'Unlimited coverage for third-party bodily injuries.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Protection for third-party property damage up to ₦3,000,000.',
				'Unlimited coverage for third-party bodily injuries.'
			],
			need_to_know: [
				'NIID and Validity: Our auto insurance policies are licensed and genuine. Once purchase and inspection is completed, the policy is automatically registered on NIID Database.',
				'Insurance Certificate: Once activated, your insurance certificate is automatically generated and emailed to you. You can always present the certificate from your email to officials or print it in a hard copy format.'
			],

			'How to claim': [
				'Login to your account and go to the claims section.',
				'Report your claim, with details of the incident.',
				'Submit a repair estimate.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	}
}
